import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogActions, MatDialogContent } from '@angular/material/dialog';

export type ModalActionsType = 'normal' | 'space-between' | 'none';

@Component({
  selector: 'iahoy-modal-layout',
  imports: [FormsModule, MatDialogActions, MatDialogContent, NgOptimizedImage, ReactiveFormsModule],
  templateUrl: './modal-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './modal-layout.component.scss'
})
export class ModalLayoutComponent {
  actionsType = input<ModalActionsType>('normal');
  hasFooter = input<boolean>(false);
}
